// react and js
import PropTypes from "prop-types";
import React from "react";

// mui
import { Card, Box, Collapse, Stack, Typography } from "@mui/material";

// components

// hooks

// layouts

// pages

// theme
import {
  CardAlertWarning,
  CardAlertError,
  CardAlertSuccess,
} from "../theme/styled";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
function CardOutlet({
  variant,
  backgroundProp,
  title,
  subheader,
  mainOutlet,
  error,
  warning,
  success,
  returnMessage,
}) {
  // ----------------------------------------------------------------------
  // Properties
  // ----------------------------------------------------------------------
  CardOutlet.propTypes = {
    variant: PropTypes.any,
    backgroundProp: PropTypes.any,
    title: PropTypes.any,
    subheader: PropTypes.any,
    mainOutlet: PropTypes.any,
    error: PropTypes.any,
    warning: PropTypes.any,
    success: PropTypes.any,
    returnMessage: PropTypes.any,
  };

  return (
    <Card
      sx={{
        background: backgroundProp,
        border: variant === "outlined" ? 1 : 0,
        borderColor: "#6D6E70",
        borderRadius: '10px',
        boxShadow: "0px 0px 5px 0px rgb(255, 255, 255)",
      }}
    >
      <Box
        sx={{
          py: {
            xs: 2,
            sm: 2,
            md: 4,
            lg: 4,
            xl: 4,
          },

          px: {
            xs: 2,
            sm: 2,
            md: 4,
            lg: 4,
            xl: 4,
          },
        }}
        dir="ltr"
      >
        {title !== undefined ? (
          <Typography
            variant="h2"
            sx={{
              mb: 1,
            }}
          >
            {title}
          </Typography>
        ) : null}

        {subheader !== undefined ? (
          <Box dir="ltr">
            <Typography variant="contentMiddle"> {subheader} </Typography>
          </Box>
        ) : null}

        {variant !== "description" ? (
          <>
            <Stack justifyContent="space-between" sx={{ my: 0 }}>
              <Collapse in={error} timeout="auto" unmountOnExit>
                <CardAlertError severity="error" sx={{ mt: 1, mb: 0 }}>
                  {returnMessage}
                </CardAlertError>
              </Collapse>
              <Collapse in={warning} timeout="auto" unmountOnExit>
                <CardAlertWarning severity="warning" sx={{ mt: 1, mb: 0 }}>
                  {returnMessage}
                </CardAlertWarning>
              </Collapse>
              <Collapse in={success} timeout="auto" unmountOnExit>
                <CardAlertSuccess severity="success" sx={{ mt: 1, mb: 0 }}>
                  {returnMessage}
                </CardAlertSuccess>
              </Collapse>
            </Stack>
            {mainOutlet}
          </>
        ) : null}
      </Box>
    </Card>
  );
}

export default CardOutlet;
